module.exports = __webpack_public_path__ + "img/nissan.a809cc01.png";